import React from "react";

const FormRadio = ({
  name,
  value,
  text,
  content,
  paymentType,
  setpaymentType,
  width = 'sm:w-1/2'
}) => {
  return (
    <div className={`${width} pl-6 pr-11 sm:h-24 py-5 sm:py-0 sm:first:border-r-2 border-['#EFF5F7']`}>
      <label className="flex items-center h-full   cursor-pointer relative pl-9">
        <input
          type="radio"
          className="w-0 h-0"
          name={name}
          value={value}
          onChange={(e) => setpaymentType(value)}
        ></input>
        <span className="font-medium text-15">{text}</span>
        <span
          className={
            "w-6 h-6 rounded-full border-[3px] absolute left-0 flex items-center justify-center before:content[''] before:w-2 before:h-2 before:bg-primary before:inline-block before:rounded-full before:transition before:transform   " +
            (paymentType == value ? "before:scale-1" : "before:scale-0")
          }
        ></span>
        <span
          className={
            "font-semibold text-xl  ml-auto " +
            (paymentType == value
              ? "text-primary opacity-100"
              : "text-black opacity-25")
          }
        >
          {content}
        </span>
      </label>
    </div>
  );
};

export default FormRadio;
